// client\src\api\axios.js

import axios from 'axios';

export const AUTH_UNAUTHORIZED_EVENT = 'gscrm:auth-unauthorized';

// Detecta o hostname correto ou usa localhost como fallback
const apiBaseURL = process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname || 'localhost'}:4000`;

// console.log('API Base URL:', apiBaseURL); // Adicione para verificar o valor durante o debug

const api = axios.create({
  baseURL: apiBaseURL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('clientAuthToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      // A rota privada decide se deve redirecionar; paginas publicas permanecem abertas.
      window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
    }
    return Promise.reject(error);
  }
);

// console.log('API Base URL:', api.defaults.baseURL);

export default api;
